import { Switch, Route, Redirect } from 'react-router-dom';

import styles from 'typescript/apps/checkout_v3/checkout_layout.module.scss';
import CompletingOrderDialog from 'typescript/apps/checkout_v3/components/completing_order_dialog/completing_order_dialog';
import NavBar from 'typescript/apps/checkout_v3/components/nav_bar';
import OrderSummary from 'typescript/apps/checkout_v3/components/order_summary/order_summary';
import Complete from 'typescript/apps/checkout_v3/pages/complete';
import Delivery from 'typescript/apps/checkout_v3/pages/delivery';
import Payment from 'typescript/apps/checkout_v3/pages/payment';
import CashAppRedirect from 'typescript/apps/checkout_v3/pages/cash_app_redirect';
import { useWindowDimensions } from 'typescript/hooks/use_window_dimensions';
import * as Breakpoints from 'typescript/utilities/breakpoints';
import { CHECKOUT_ROUTES } from 'typescript/constants/enums/checkout';

const Main = () => (
  <div className={styles.mainContainer}>
    <Switch>
      <Route path={CHECKOUT_ROUTES.DELIVERY} component={Delivery} />
      <Route path={CHECKOUT_ROUTES.PAYMENT} component={Payment} />
      <Route path={CHECKOUT_ROUTES.CASH_APP_PAY} component={CashAppRedirect} />
      <Route path={CHECKOUT_ROUTES.COMPLETE} component={Complete} />
      <Redirect to={CHECKOUT_ROUTES.DELIVERY} />
    </Switch>
  </div>
);

const Checkout = () => {
  const { matchesMinWidth } = useWindowDimensions();
  const isDesktopView = matchesMinWidth(Breakpoints.md);

  return (
    <div className={styles.checkoutContainer}>
      <CompletingOrderDialog />
      <NavBar />
      <div className={styles.componentsContainer}>
        <Main />
        {isDesktopView && <OrderSummary />}
      </div>
    </div>
  );
};

export default Checkout;
